import { Box, ButtonLink, Heading, RichText, Stack } from '@ads-core/components';

interface CongestionManagementProps {
  congestionManagementTitle?: string;
  reportDates?: string;
  researchApplicableText?: string;
  congestionReport?: {
    congestionManagementResearchSummary?: string;
    contentServerLink?: string;
  };
  downloadReportButtonLabel?: string;
}

export const CongestionManagement = (props: CongestionManagementProps) => {
  const {
    congestionManagementTitle,
    reportDates,
    researchApplicableText,
    congestionReport,
    downloadReportButtonLabel,
  } = props;

  return (
    <Stack gap={8} asChild>
      <Box overflow="hidden">
        {congestionManagementTitle ? (
          <Heading size="h3">{congestionManagementTitle}</Heading>
        ) : null}
        {reportDates ? <RichText>{reportDates}</RichText> : null}
        {researchApplicableText ? <RichText>{researchApplicableText}</RichText> : null}
        {congestionReport?.congestionManagementResearchSummary ? (
          <RichText>{`<p>${congestionReport.congestionManagementResearchSummary}</p>`}</RichText>
        ) : null}
        {congestionReport?.contentServerLink ? (
          <Box>
            <ButtonLink href={congestionReport.contentServerLink} target="_blank">
              {downloadReportButtonLabel ? downloadReportButtonLabel : 'Download het rapport'}
            </ButtonLink>
          </Box>
        ) : (
          <RichText>{'<p>Er is nog geen rapport beschikbaar.</p>'}</RichText>
        )}
      </Box>
    </Stack>
  );
};
